import { FC } from 'react'
import { ResetPasswordTemplate } from '../templates'

export const ResetPasswordPage: FC = () => {
  return (
    <ResetPasswordTemplate />
  )
}